import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const InstantBookingContext = createContext();

export const InstantBookingProvider = ({
  children,
  isEnabled,
  rules = null
}) => {
  return (
    <InstantBookingContext.Provider value={{ isEnabled, rules }}>
      {children}
    </InstantBookingContext.Provider>
  );
};

InstantBookingProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  isEnabled: PropTypes.bool.isRequired,
  rules: PropTypes.shape({
    params: PropTypes.shape(),
    type: PropTypes.string
  })
};

export const useInstantBooking = () => useContext(InstantBookingContext) || {};

export default {
  InstantBookingProvider,
  useInstantBooking
};
